import { render } from "./AuctionItemCarousel.vue?vue&type=template&id=53828960"
import script from "./AuctionItemCarousel.vue?vue&type=script&lang=js"
export * from "./AuctionItemCarousel.vue?vue&type=script&lang=js"

import "./AuctionItemCarousel.vue?vue&type=style&index=0&id=53828960&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__